module.exports = __webpack_public_path__ + "static/media/bot.217e7a82.png";